var irreducible = require('./irreducible');

module.exports = irreducible('Error', function (x) { return x instanceof Error; });



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Error.js
// module id = 411
// module chunks = 0